import { z } from 'zod';
import { themeSchema } from '@loop/shared';
/**
 * Widget Theme REST DTO — Phase 5 / Plan 05-02 (WIDGET-05).
 *
 * 엔드포인트:
 *   - `GET  /api/v1/widgets/:streamerId/theme`  — 공개 (OBS 브라우저 소스가 boot 시 호출)
 *   - `PUT  /api/v1/widgets/me/theme`           — 스트리머 세션 필수 (대시보드 에디터)
 *
 * 단일 소스:
 *   - body · response 는 `themeSchema` (packages/shared/src/theme.ts v1.0.0) 와 동일.
 *   - PUT request body 는 raw unknown — 서버의 `parseTheme` 가 Zod + migrateTheme 검증.
 *   - 저장 성공 시 응답은 `themeSchema` 로 parsed (= valid theme) 반환.
 *
 * CORS (05-02-PLAN <action>):
 *   - GET : OBS 브라우저 소스 origin 제약 없음 → `Access-Control-Allow-Origin: *`.
 *   - PUT : apps/web (대시보드) 만 허용 — Controller 레벨에서 제어 (Wave 1 global CORS 정책).
 */
/** GET 응답 — 현재 저장된 theme (없으면 default) 반환. */
export const getWidgetThemeResponseSchema = themeSchema;
/**
 * PUT request body — 서버가 parseTheme(raw, defaultTheme) 으로 검증.
 *
 * unknown 타입으로 느슨하게 선언한 이유:
 *   1) 저장 전 migrateTheme 적용 기회 확보 (v1.0.0 → future 단계적 승급).
 *   2) 잘못된 body 도 400 error response 가 parseTheme 의 errors 배열을 반환 —
 *      HTTP 레이어 ZodError 가 아닌 서비스 레벨 에러로 통일.
 */
export const putWidgetThemeRequestSchema = z.unknown();
/**
 * PUT 응답 — 저장된 theme + meta.
 *
 * `theme` 은 항상 v1.0.0 (서버에서 parseTheme 통과한 값만 저장).
 * `updatedAt` ISO 8601 — 클라이언트 재요청 폴링 or 업데이트 애니메이션 트리거.
 */
export const putWidgetThemeResponseSchema = z.object({
    streamerId: z.string().uuid(),
    theme: themeSchema,
    updatedAt: z.string().datetime({ offset: true }),
});
//# sourceMappingURL=widget-theme.rest.js.map